/* eslint-disable */
import { FormatCountryCacheMixin } from "@/mixins/Booking/FormatCountryCacheMixin";

export const MobileValidatorMixin = {
    mixins: [FormatCountryCacheMixin],
    data() {
        return {
            message: ''
        }
    },
    computed: {
        mobileRegex() {
            return !!this.countryFormat ? new RegExp(this.countryFormat.mobileFormat) : new RegExp();
        },
        sampleFormat() {
            return !!this.countryFormat ? this.countryFormat.sampleFormat : '';
        },
        isDefaultMobileFormat() {
            return !!this.countryFormat ? this.countryFormat.isDefaultMobileFormat : true;
        }
    },
    methods: {
        validateMobile(value) {
            this.message = '';
            this.message = value.match(new RegExp(this.mobileRegex)) ? '' :
            `Invalid format for ${this.countryName}.` + (!this.isDefaultMobileFormat ? ` Sample: ${this.sampleFormat}.` : '');
        }
    }
}
